// Extract city from subdomain (e.g., fatehabad.digitalfatehabad.com, fatehabad.idbf.in)
// Excludes "www" so www.digitalfatehabad.com is treated as the main site, not "city = www"
export const getCityFromHost = () => {
  // Always return 'fatehabad' as the default city, ignoring subdomains
  return 'fatehabad';
};

export const getCitySlug = () => {
  return getCityFromHost();
};

